// This file is autogenerated. Please don't modify it directly. See the README for details
/* tslint:disable */
import MiniCommonIcons from './MiniCommonIcons';

export type MiniCommonIconsSubset = { [icon in MiniCommonIcons]: string };

export let MiniCommonIconsDefinitions: MiniCommonIconsSubset = {
    OfficeLogo: '\ueb6e',
    OutlookLogo: '\uf1e9',
};

export default {
    fontFileName: 'miniCommonIcons',
    icons: MiniCommonIconsDefinitions,
};
